// eslint-disable-next-line import/prefer-default-export
import {FilterType} from "./filterType"
import Filter, {MatchMode} from "../../metstat/models/filter"

export enum VariableTypeEnum {
    gender,
    age,
    bmi,
    fitness,
    ethnicity,
    nutrition,
    date,
    fasting_status,
    smoking,
    alcohol,
}

interface VariableType {
    value: string
}

export const VariableTypeProperties: {
    [key in VariableTypeEnum]: VariableType
} = {
    [VariableTypeEnum.gender]: {
        value: "Gender",
    },
    [VariableTypeEnum.age]: {
        value: "Age",
    },
    [VariableTypeEnum.bmi]: {
        value: "BMI",
    },
    [VariableTypeEnum.fitness]: {
        value: "Fitness",
    },
    [VariableTypeEnum.ethnicity]: {
        value: "Ethnicity",
    },
    [VariableTypeEnum.nutrition]: {
        value: "Nutrition",
    },
    [VariableTypeEnum.date]: {
        value: "Date of upload",
    },
    [VariableTypeEnum.fasting_status]: {
        value: "Fasting status",
    },
    [VariableTypeEnum.smoking]: {
        value: "Smoking",
    },
    [VariableTypeEnum.alcohol]: {
        value: "Alcoholic drinks per week",
    },
}

export const Filters: {
    [key in VariableTypeEnum]: Filter
} = {
    [VariableTypeEnum.gender]: {
        name: VariableTypeProperties[VariableTypeEnum.gender].value,
        filterType: FilterType.category,
        enable: false,
        matchMode: MatchMode.equalsIgnoreCase,
        value: "",
        from: undefined,
        to: undefined,
    },
    [VariableTypeEnum.age]: {
        name: VariableTypeProperties[VariableTypeEnum.age].value,
        filterType: FilterType.category,
        enable: false,
        matchMode: MatchMode.between,
        value: undefined,
        from: "",
        to: "",
    },
    [VariableTypeEnum.bmi]: {
        name: VariableTypeProperties[VariableTypeEnum.bmi].value,
        filterType: FilterType.category,
        enable: false,
        matchMode: MatchMode.between,
        value: undefined,
        from: "",
        to: "",
    },
    [VariableTypeEnum.fitness]: {
        name: VariableTypeProperties[VariableTypeEnum.fitness].value,
        filterType: FilterType.category,
        enable: false,
        matchMode: MatchMode.isIn,
        value: "",
        from: undefined,
        to: undefined,
    },
    [VariableTypeEnum.ethnicity]: {
        name: VariableTypeProperties[VariableTypeEnum.ethnicity].value,
        filterType: FilterType.category,
        enable: false,
        matchMode: MatchMode.isIn,
        value: [],
        from: undefined,
        to: undefined,
    },
    [VariableTypeEnum.nutrition]: {
        name: VariableTypeProperties[VariableTypeEnum.nutrition].value,
        filterType: FilterType.category,
        enable: false,
        matchMode: MatchMode.isIn,
        value: [],
        from: undefined,
        to: undefined,
    },
    [VariableTypeEnum.date]: {
        name: VariableTypeProperties[VariableTypeEnum.date].value,
        filterType: FilterType.category,
        enable: false,
        matchMode: MatchMode.dateLessEquals,
        value: "",
        from: undefined,
        to: undefined,
    },
    [VariableTypeEnum.fasting_status]: {
        name: VariableTypeProperties[VariableTypeEnum.fasting_status].value,
        filterType: FilterType.category,
        enable: false,
        matchMode: MatchMode.equals,
        value: "",
        from: undefined,
        to: undefined,
    },
    [VariableTypeEnum.smoking]: {
        name: VariableTypeProperties[VariableTypeEnum.smoking].value,
        filterType: FilterType.category,
        enable: false,
        matchMode: MatchMode.isIn,
        value: "",
        from: undefined,
        to: undefined,
    },
    [VariableTypeEnum.alcohol]: {
        name: VariableTypeProperties[VariableTypeEnum.alcohol].value,
        filterType: FilterType.category,
        enable: false,
        matchMode: MatchMode.between,
        value: undefined,
        from: "",
        to: "",
    },
}

export const genderMap = new Map([
    ["male", "m"],
    ["female", "f"],
    ["m", "male"],
    ["f", "female"],
])
